import { useDeleteProjectMapMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";
import getLocalString from "constants/Localization";

export default function useDeleteProjectMap() {
  const [mutation, { data, loading, error }] = useDeleteProjectMapMutation({
    refetchQueries: ["customGetProjectMaps"],
  });

  const [deleteProjectMap, context] = useBitumioMutation(
    { mutation, data, loading, error, key: "deleteProjectMap" },
    {
      successMessage: getLocalString("projectMaps.delete-success"),
      failureMessage: getLocalString("projectMaps.delete-failure"),
    }
  );

  return [deleteProjectMap, context] as const;
}
